export default class Quicklinks {
	constructor(config) {
		this.el = config.el || document.querySelectorAll(".quicklinks");
		this.triggers = this.el.querySelectorAll(".quicklinks__trigger");
		this.panels = this.el.querySelectorAll(".quicklinks__panel");
		this.links = this.el.querySelectorAll(".quicklinks_link");
		this.items = this.el.querySelectorAll(".quicklinks__group");
		this.visibleClassSmall = "quicklinks--panel-visible";
		this.panelSelector = ".quicklinks__panel";
		utilities.dataStorage.put(this.el, "component", this);
		this.currentMode = "";
		this.init();
	}
	init() {
		if (utilities.isMobile()) {
			this.buildAccordion();
			this.checkHash();
			this.currentMode = "mobile";
		}

		this.attachEvents();

		// Attach event listener for window resize
		window.addEventListener("resize", this.windowResized.bind(this), false);
	}

	windowResized() {
		if (utilities.isMobile()) {
			// Do not modify if it already is in mobile mode.
			if (this.currentMode !== "mobile") {
				this.checkHash();
				this.buildAccordion();
				this.currentMode = "mobile";
				this.attachEvents();
			}
		} else {
			if (this.currentMode !== "desktop") {
				this.destroyAccordion();
				this.currentMode = "desktop";
				this.attachEvents();
			}
		}
	}

	attachEvents() {
		const self = this;
		this.triggers.forEach(el => {
			el.addEventListener("click", e => {
				if (utilities.isMobile()) {
					self.toggleAccordionItem(e);
				}
			});
		});
	}
	checkHash() {
		let hash = window.location.hash;
		if (hash) {
			hash = decodeURI(hash);
			const elementMatch = this.el.querySelector(hash);
			if (elementMatch) {
				this.showPanel(elementMatch);
			}
		}
	}
	destroyAccordion() {
		// Step 1 - Convert buttons back to divs
		for (let i = 0; i < this.triggers.length; i++) {
			const el = this.triggers[i];

			// Preserve the inner html elements!
			const umbracoElKey = el.dataset.key;

			const div = document.createElement("div");

			div.classList.add("quicklinks__trigger");
			div.setAttribute("data-key", umbracoElKey);

			while (el.hasChildNodes()) {
				div.append(el.removeChild(el.firstChild));
			}

			el.replaceWith(div);

			div.addEventListener("click", e => {
				this.toggleAccordionItem(e);
			});

			// Remove event listener from button
			el.removeEventListener("click", e => {
				this.toggleAccordionItem(e);
			});
		}

		// Reset the triggers array so that it contains divs again
		this.triggers = this.el.querySelectorAll(".quicklinks__trigger");

		// Step 3 - remove attributes from panels
		for (let i = 0; i < this.panels.length; i++) {
			const el = this.panels[i];
			el.removeAttribute("role");
			el.removeAttribute("hidden");
		}

		// Remove event listener from this.el
		this.el.removeEventListener(
			"keydown",
			this.accordionHotkeys.bind(this)
		);
	}

	buildAccordion() {
		// Step 1 - Convert divs to buttons!
		for (let i = 0; i < this.triggers.length; i++) {
			const el = this.triggers[i];

			// Preserve the inner html elements!
			const umbracoElKey = el.dataset.key;

			const btn = document.createElement("button");
			btn.classList.add("quicklinks__trigger");
			btn.setAttribute("aria-controls", `sect-${umbracoElKey}`);
			btn.setAttribute("aria-expanded", "false");
			btn.setAttribute("data-key", umbracoElKey);

			btn.tabIndex = 0;

			while (el.hasChildNodes()) {
				btn.append(el.removeChild(el.firstChild));
			}

			el.replaceWith(btn);
		}

		// Step 2 - Reset the triggers array so that it contains the buttons
		this.triggers = this.el.querySelectorAll(".quicklinks__trigger");

		// Step 3 - Append to panels
		for (let i = 0; i < this.panels.length; i++) {
			const el = this.panels[i];

			const umbracoElKey = el.dataset.key;
			// Lets modify !
			el.setAttribute("role", "region");
			el.setAttribute("hidden", "true");
			el.id = `sect-${umbracoElKey}`;
		}

		// Step 4 - Build keybindings !
		this.el.addEventListener("keydown", this.accordionHotkeys.bind(this));
	}

	accordionHotkeys(e) {
		const target = e.target;
		const key = e.which.toString();

		// 33 = Page Up, 34 = Page Down
		const ctrlModifier = e.ctrlKey && key.match(/33|34/);
		const triggers = Array.prototype.slice.call(this.triggers);
		if (target.classList.contains("quicklinks__trigger")) {
			if (key.match(/38|40/) || ctrlModifier) {
				const index = triggers.indexOf(target);

				const direction = key.match(/34|40/) ? 1 : -1;
				const length = triggers.length;
				const newIndex = (index + length + direction) % length;
				triggers[newIndex].focus();

				e.preventDefault();
			} else if (key.match(/35|36/)) {
				switch (key) {
					case "36":
						triggers[0].focus();
						break;
					case "35":
						triggers[triggers.length - 1].focus();
						break;
				}
				e.preventDefault();
			}
		}
	}

	toggleAccordionItem(e) {
		const trigger = e.currentTarget;
		const quickLinkGroup = trigger.parentElement;

		if (quickLinkGroup.classList.contains(this.visibleClassSmall)) {
			this.hidePanel(quickLinkGroup);
		} else {
			this.showPanel(quickLinkGroup);
		}
	}
	hidePanel(quickLinkGroup) {
		utilities.resetHashUrl();
		quickLinkGroup.classList.remove(this.visibleClassSmall);
		let panel = quickLinkGroup.querySelector(this.panelSelector);

		if (utilities.isMobile()) {
			panel.style.height = "0px";
			const btn = quickLinkGroup.querySelector("button");
			if (btn !== null) btn.setAttribute("aria-expanded", "false");

			quickLinkGroup
				.querySelector(".quicklinks__panel")
				.setAttribute("hidden", "true");
		}
	}
	showPanel(quickLinkGroup, preventSetHash) {
		// hide all others first
		this.hideAllPanels();

		let panel = quickLinkGroup.querySelector(this.panelSelector);
		if (utilities.isMobile()) {
			// set aria-expanded on button
			const btn = quickLinkGroup.querySelector("button");
			if (btn !== null) btn.setAttribute("aria-expanded", "true");
			panel.removeAttribute("hidden");
		}

		quickLinkGroup.classList.add(this.visibleClassSmall);
		// set height
		panel.style.height = panel.scrollHeight + "px";
		if (!preventSetHash) {
			//set the url corresponding to id so we can deeplink
			utilities.setHashUrl(quickLinkGroup.getAttribute("id"));
		}
	}
	hideAllPanels() {
		this.panels.forEach(panel => {
			this.hidePanel(panel.parentElement);
		});
	}
	resetHeight() {
		this.el.style.height = "";
	}
	updateHeight(currentItem) {
		let tallestTrigger = 0;
		this.triggers.forEach(item => {
			if (item.scrollHeight > tallestTrigger) {
				tallestTrigger = item.scrollHeight;
			}
		});
		let currentPanelHeight = currentItem.querySelector(".tabs__panel")
			.scrollHeight;
		this.el.style.height = tallestTrigger + currentPanelHeight + "px";
	}
}
